import { useEffect, useState } from "react";

import { cloneDeep } from "lodash";

import MomSysShipDialog from "../dialogTypes/MomSysShipDialog";
import CreateRecordButton from "./CreateRecordButton";

function MomSyShipButton (props) {

    const {id, grid, refresh, schema, createButtonName, onSuccess, customizeErrorMsgCallback, ...others} = props;
    
    const [ open, setOpen ] = useState(false);

    const [modifiedSchema, setModifiedSchema] = useState();

    useEffect(() => {

        if(schema) {

            let modifiedSchema = cloneDeep(schema);

            let orderBuyerIdColumn = {};

            orderBuyerIdColumn.name = "orderBuyerId";

            orderBuyerIdColumn.readonly = true;
            orderBuyerIdColumn.disabled = true;

            orderBuyerIdColumn.formGroup = 0;
            orderBuyerIdColumn.formOrder = 1;
            orderBuyerIdColumn.formItemType = "text";


            modifiedSchema.columns.push (orderBuyerIdColumn);

             let orderBuyerNameColumn = {};

            orderBuyerNameColumn.name = "orderBuyerName";

            orderBuyerNameColumn.readonly = true;
            orderBuyerNameColumn.disabled = true;

            orderBuyerNameColumn.formGroup = 0;
            orderBuyerNameColumn.formOrder = 2;
            orderBuyerNameColumn.formItemType = "text";

            modifiedSchema.columns.push (orderBuyerNameColumn);

            let shipmentNo = {};

            shipmentNo.name = "shipmentNo";

            shipmentNo.readonly = true;
            shipmentNo.disabled = true;

            shipmentNo.formGroup = 0;
            shipmentNo.formOrder = 3;
            shipmentNo.formItemType = "text";


            modifiedSchema.columns.push (shipmentNo); 

            let shipmentOrderDate = {};

            shipmentOrderDate.name = "shipmentOrderDate";

            shipmentOrderDate.readonly = true;
            shipmentOrderDate.disabled = true;

            shipmentOrderDate.formGroup = 0;
            shipmentOrderDate.formOrder = 5;
            shipmentOrderDate.formItemType = "text";

            modifiedSchema.columns.push (shipmentOrderDate);
             
            let dueDateColumn = {};

            dueDateColumn.name = "dueDate";

            dueDateColumn.readonly = true;
            dueDateColumn.disabled = true;

            dueDateColumn.formGroup = 0;
            dueDateColumn.formOrder = 6;
            dueDateColumn.formItemType = "text";


            modifiedSchema.columns.push (dueDateColumn); 
            
            setModifiedSchema(modifiedSchema)
        }

    },[schema])
    
    const onOpen = () => {

        setOpen ( true );
    };

    const onClose = () => {

        setOpen ( false );

    };

    const onShipSuccess = (msg) => {

        if (onSuccess) {
    
          onSuccess(msg);
    
        }
        refresh.refresh();
    
    };


    return (
        <>
        <CreateRecordButton id = {id+"-ship-button"} onClick = {onOpen} createButtonName ={createButtonName} {...others}/>
        <MomSysShipDialog
                id={id+"ship-dialog"}
                schema={modifiedSchema}
                open={open}
                onClose={onClose}
                onSuccess={onShipSuccess}
            />
        </>
    )

}

export default MomSyShipButton;